export const USER_EVENTS_CONSTANTS = {
	CLICKED_SEARCH_ROUTES_BUTTON: 'CLICOU NO BOTÃO DE BUSCAR ROTAS',
	PURCHASE_COMPLETION: 'FINALIZAÇÃO DA COMPRA',
}
